export const menuData =  [
    {title: "Home", link: "/#home"},
    {title: "Services", link: "/#services"},
    {title: "How it works?", link: "/#howitworks"},
    {title: "FAQs", link: "/#faqs"},
    {title: "Sign Up", link: "/#signup"},
    {title: "Contact Us", link: "/#contact"},
]